import { get } from "../services/APIHandler";

class ValidationMessageService {
  static getValidationMessageData = () => {
    return new Promise((resolve, reject) => {
      get("../../validationMessage.json", (error, response) => {
        if (error) {
          reject([]);
        } else {
          let res = response.data;
          resolve(res);
        }
      });
    });
  };
}

export default ValidationMessageService;
